import React from 'react';
import moment from 'moment';
import {
  CardInfo,
  CardInfoItem,
  CardInfoText,
  CardInfoValueType,
  FlexItem,
  H3,
} from '@erecruit/ui-kit';
import { Intl } from '@erecruit/core';
import { Authorize } from '@erecruit/modules';
import {
  Resources,
  InexactDurationUnit,
  AppPermissions,
} from '@erecruit/types';

import SectionContextMenu from '../SectionContextMenu';
import { BaseSectionProps } from '../../types';
import {
  DATE_FORMAT,
  DEFAULT_SHIFT_FORMAT,
  US_TIME_FORMAT,
} from '../../../../constants';

const { FormattedMessage } = Intl;

export default ({
  data,
  expanded,
  isMyOwn,
  onEdit,
}: BaseSectionProps<Resources.PositionSchedule>) => {
  const {
    durationAmount,
    durationUnit,
    endTime,
    estimatedEndDate,
    estimatedStartDate,
    shiftTypes,
    startTime,
  } = data;

  const startTimeFormatted = moment(startTime, DEFAULT_SHIFT_FORMAT).format(
    US_TIME_FORMAT,
  );
  const endTimeFormatted = moment(endTime, DEFAULT_SHIFT_FORMAT).format(
    US_TIME_FORMAT,
  );

  return (
    <FlexItem>
      <CardInfo
        showDetails={expanded}
        title={
          <H3 align="center">
            <FormattedMessage
              id={messageIds.vms.positionRecord.schedule.title}
            />
          </H3>
        }
        config={{ dateFormat: DATE_FORMAT }}
        extra={
          <Authorize
            permission={`(${AppPermissions.EditPositions} | (${AppPermissions.EditMyOwnPositions} & ${isMyOwn}) ) & ${AppPermissions.EditPositionSchedule}`}
          >
            <SectionContextMenu section="schedule" onEdit={onEdit} />
          </Authorize>
        }
      >
        <CardInfoText
          label={
            <FormattedMessage
              id={messageIds.vms.positionRecord.schedule.duration}
            />
          }
          value={
            durationAmount && durationUnit
              ? `${durationAmount} ${InexactDurationUnit[durationUnit]}${
                  durationAmount > 1 ? 's' : ''
                }`
              : undefined
          }
        />
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.positionRecord.schedule.estimatedStartDate}
            />
          }
          type={CardInfoValueType.Date}
          value={estimatedStartDate}
        />
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.positionRecord.schedule.estimatedEndDate}
            />
          }
          type={CardInfoValueType.Date}
          value={estimatedEndDate}
        />
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.positionRecord.schedule.shiftType}
            />
          }
          type={CardInfoValueType.MultiSelect}
          value={shiftTypes[0]?.name || '-'}
        />
        <CardInfoText
          label={
            <FormattedMessage
              id={messageIds.vms.positionRecord.schedule.startTime}
            />
          }
          value={startTime ? startTimeFormatted : '-'}
        />
        <CardInfoText
          value={endTime ? endTimeFormatted : '-'}
          label={
            <FormattedMessage
              id={messageIds.vms.positionRecord.schedule.endTime}
            />
          }
        />
      </CardInfo>
    </FlexItem>
  );
};
